import React from 'react';
import { translate } from 'react-i18next';

import OfflineTooltip from 'components/OfflineTooltip';
import EmployeeActions from 'actions/EmployeeActions';
import naStyle from 'utils/naColour';

class UnavailableSidebarItem extends React.Component {

  removeRequest() {
    EmployeeActions.cancelTimeOffRequest(this.props.requestId, this.props.id);
  }

  // N/A Days are self-declared and self-removed (no manager request). The
  // declaring department's self-removal policy + publish state are enforced
  // server-side; we surface any rejection optimistically (handled by the parent).
  removeNaButton() {
    // No handler, no button: the self-schedule page shows N/A days but never changes them.
    if (!this.props.onRemoveNa) return '';
    // Optimistic otherwise: always offer removal. Publication is enforced server-side
    // (rejected with reason "schedule_published"); the parent surfaces that.
    return (
      <button
        onClick={() => this.props.onRemoveNa(this.props.id)}
        className="calendar-input-button cancel-timeoff-button remove-na-button"
      >
        {' '}
        {this.props.t('na.labels.self_remove_button')}
        {' '}
      </button>
    );
  }

  cancelRequestButton(state, source) {
    if (state == 'new' && source != 'adp' && source != 'e_days') {
      return (
        <OfflineTooltip>
          <button
            onClick={() => this.removeRequest()}
            className="calendar-input-button cancel-timeoff-button"
            disabled={!Utils.isOnline()}
          >
            {' '}
            {this.props.t('UnavailableSidebarItem.cancel_request')}
            {' '}
          </button>
        </OfflineTooltip>
      );
    }
    return '';
  }

  timeOffNotes(notes) {
    if (!Utils.isNotDefined(notes) || notes !== '') {
      return (
        <span className="time-off-notes">
          <strong>{this.props.t('UnavailableSidebarItem.notes')}</strong>
          {notes}
        </span>
      );
    }
    return '';
  }

  dateRange(startDate, endDate) {
    if (startDate !== endDate) {
      return (
        <span>
          {`${startDate} - `}
          <br />
          {endDate}
        </span>
      );
    }
    return <span>{startDate}</span>;
  }

  render() {
    return (
      <li>
        {/* N/A Days are self-declared (auto-approved, no request), so the
            "Approved" state text doesn't apply — hide it for N/A rows. */}
        {!this.props.na && (
          <span className="pending-item">{this.props.displayedState}</span>
        )}
        <div style={{maxWidth: 190}}>
          {this.props.na && (
            <span className="na-badge" style={this.props.colour ? naStyle(this.props.colour) : null}>
              {this.props.t('na.staff.picker.na_badge')}
            </span>
          )}
          {this.props.typeName}
        </div>
        {' '}
        <br />
        {this.dateRange(this.props.startDate, this.props.endDate)}
        {' '}
        <br />
        {this.props.hoursRange}
        {this.timeOffNotes(this.props.notes)}
        {this.props.na
          ? this.removeNaButton()
          : this.cancelRequestButton(this.props.state, this.props.source)}
      </li>
    );
  }
}

export default translate()(UnavailableSidebarItem);
